// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__XUorT","ui-modal-rise":"Modal_ui-modal-rise__LP4ra","header":"Modal_header__KOM1y","headerTitle":"Modal_headerTitle__Mpvac"};